import { render, staticRenderFns } from "./FWJH.vue?vue&type=template&id=6a4ace20&scoped=true&"
import script from "./FWJH.vue?vue&type=script&lang=js&"
export * from "./FWJH.vue?vue&type=script&lang=js&"
import style0 from "./FWJH.vue?vue&type=style&index=0&id=6a4ace20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ace20",
  null
  
)

export default component.exports